(() => {
  document.querySelectorAll('[data-gh-home]').forEach((root) => {
    const video = root.querySelector('[data-gh-routine-video]');
    const videoToggle = root.querySelector('[data-gh-video-toggle]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let manuallyPaused = reduceMotion;

    const syncVideoToggle = () => {
      if (!video || !videoToggle) return;
      const paused = video.paused;
      videoToggle.setAttribute('aria-pressed', String(paused));
      videoToggle.setAttribute('aria-label', paused ? 'Play lifestyle video' : 'Pause lifestyle video');
      const label = videoToggle.querySelector('span');
      if (label) label.textContent = paused ? 'Play' : 'Pause';
    };

    if (video && videoToggle) {
      if (reduceMotion) video.pause();
      videoToggle.addEventListener('click', () => {
        if (video.paused) {
          manuallyPaused = false;
          video.play().catch(() => {});
        } else {
          manuallyPaused = true;
          video.pause();
        }
        syncVideoToggle();
      });
      video.addEventListener('play', syncVideoToggle);
      video.addEventListener('pause', syncVideoToggle);
      syncVideoToggle();

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) video.pause();
            else if (!manuallyPaused) video.play().catch(() => {});
          });
        }, { threshold: 0.25 });
        observer.observe(video);
      }
    }

    root.querySelector('[data-gh-share]')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const url = button.dataset.shareUrl || window.location.href;
      if (navigator.share) {
        try { await navigator.share({ title: "The GLISS'N Guide", url }); } catch (_) {}
        return;
      }
      try {
        await navigator.clipboard.writeText(url);
        const original = button.textContent;
        button.textContent = 'Link copied!';
        window.setTimeout(() => { button.textContent = original; }, 1800);
      } catch (_) {
        window.location.href = url;
      }
    });
  });
})();
